export function SectionLabel({ children, num }) {
    return (
        <div className="inline-flex items-center gap-3 text-[11px] font-semibold tracking-[0.24em] uppercase text-neutral-500">
            {num && (
                <span className="font-mono-alt text-violet-500">{num}</span>
            )}
            <span className="h-px w-6 bg-neutral-300" />
            {children}
        </div>
    );
}

export function SectionHeading({ children, className = "" }) {
    return (
        <h2
            className={`font-display text-4xl sm:text-5xl lg:text-[64px] leading-[1.03] tracking-tight font-light text-black ${className}`}
        >
            {children}
        </h2>
    );
}
